import { Language } from '../../../common/languages.js';
import { BingoCommonClass, IBingoCommon } from './common.js';
import { BingoLangClass, IBingoLangState } from './lang.js';

export interface IBingoData {
  common: IBingoCommon;
  lang: IBingoLangState;
}

export class BingoDataClass implements IBingoData {
  common: IBingoCommon;
  lang: IBingoLangState;

  constructor(data?: Partial<IBingoData>) {
    this.common = data?.common ?? new BingoCommonClass();
    this.lang =
      data?.lang ??
      Object.values(Language).reduce((acc, lang) => {
        acc[lang] = new BingoLangClass();
        return acc;
      }, {} as IBingoLangState);
  }
}
